<template>
    <div>
        <div class="flex-row">
            <el-input
                :placeholder="parameters.default_value" 
                v-model="amount"
                @blur="isFocus = false;"
                @focus="isFocus = true;"
                :min="parseInt(parameters.min_value)"
                :max="parseInt(parameters.max_value)"
                :controls="false">
            </el-input>
            <el-select v-model="value.currency" class="ml-2" :disabled="restrictedCurrency">
                <el-option v-for="(allowedValue, index) in currencies" :key="index" 
                    :label="allowedValue.name" 
                    :value="allowedValue.name">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import CfMixin from 'mixins/CustomfieldsMixins';
    import { createNamespacedHelpers } from 'vuex';

    const systemMapState  = createNamespacedHelpers('system').mapState;

    export default {
        mixins: [CfMixin],

        data(){
            return {
                /**
                 * LocalValue is needed for format Amount value and trigger store in same time
                 */
                localValue: {
                    amount: null, 
                    userValue: null,
                    currency: null
                },
                amountNumberFormat: {...window.App.numformat},
                restrictedCurrency: false,
                isFocus: false,
            }
        },

        created(){
            this.localValue = {
                ...this.localValue,
                ...this.value,
            };

            this.localValue.userValue = this.localValue.amount;

            this.restrictedCurrency = !_.isNil(this.parameters.currency);
        },

        computed: {
            /**
             * Get Amount value on input focus to format with user NumberFormat
             * Amount sended and amount typed by user must be distinct for Vue Input binding
             * @return {object} : {
             *      userValue: current Input value without format,
             *      amount: formatted amount to stringify Float for APIv2,
             *      currency: currency id
             * }
             */
            amount: {
                get() {
                    return this.isFocus ? this.localValue.userValue : NumberFormat.formatToDisplay(this.decimalValueFloat(this.localValue.userValue), this.amountNumberFormat, false);
                },
                set(amount) {
                    this.localValue.userValue = amount;
                    this.$emit('input', { id: this.id, value: {
                            amount:  this.decimalValueFloat(amount).toString(),
                            currency: this.value.currency
                        } 
                    });
                }
            },
            ...systemMapState([
                'currencies'
            ]),
            /**
             * Returns label of currency selected
             */
            currency(){
                return this.currencies.find(value => parseInt(value.id) == this.value.currency)?.name;
            },
        },

        methods: {
            /**
             * Returns the float value of decimalValue
             */
            decimalValueFloat(decimalValue) {
                return NumberFormat.formatToFloat(decimalValue, this.amountNumberFormat);
            },
        },
        watch: {
            value(amount) {
                this.localValue = { ...this.localValue, ...amount };
            }
        }
    }
</script>
